import { render, staticRenderFns } from "./GameFeedback.vue?vue&type=template&id=9f912a10&scoped=true&"
import script from "./GameFeedback.vue?vue&type=script&lang=js&"
export * from "./GameFeedback.vue?vue&type=script&lang=js&"
import style0 from "./GameFeedback.vue?vue&type=style&index=0&id=9f912a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f912a10",
  null
  
)

export default component.exports